import * as z from 'zod';

export const GroupTypeSchema = z.enum(['Primary', 'Secondary'])

export type GroupType = z.infer<typeof GroupTypeSchema>;